import React from "react";
import {Autocomplete, Card, Container, TextField} from "@mui/material";
import { observer } from 'mobx-react-lite';
import {DashboardHeader} from "../../../../UIKit/DashboardHeader";
import {useUiContext} from "../../../../UIProvider";
import {useMenstrualCycleEditing} from "../../presenters/useMenstrualCycleEditing";

export const MenstrualCycleEditing = observer(() => {
    const { t } = useUiContext();

    const {
        onUpdateMenstrualCycle,
        recommendationContentOptions,
        currentContentRecommendations,
        isOptionChosen,
        handleChange
    } = useMenstrualCycleEditing();

    return (
        <Container maxWidth="xl">
            <DashboardHeader title={t("menstrualCycles.editMenstrualPhase")} buttonTitle={t("common.save")} onPress={onUpdateMenstrualCycle} />
            <Card sx={{ p: 2, mb: 2 }}>
                <Autocomplete
                    multiple
                    options={recommendationContentOptions}
                    value={currentContentRecommendations}
                    onChange={handleChange}
                    getOptionLabel={option => option.label}
                    isOptionEqualToValue={isOptionChosen}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t("menstrualCycles.chooseRecommendations")}
                            variant="outlined"
                        />
                    )}
                    renderOption={(props, option, { selected }) => (
                        <li
                            {...props}
                            key={option.id}
                            style={{
                                backgroundColor: selected ? '#f2eee4' : 'inherit',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = selected ? '#f2eee4' : 'rgba(242, 238, 228, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = selected ? '#f2eee4' : 'inherit';
                            }}
                        >
                            {option.label}
                        </li>
                    )}
                />
            </Card>
        </Container>
    )
})